import type {RefObject} from "react";
import {createContext} from "react";

export type AppShellRefs = {
  shellRef: RefObject<HTMLDivElement | null>;
  contentRef: RefObject<HTMLElement | null>;
};

// lets the footer attach page-wide gestures without every page wiring up refs
export const AppShellContext = createContext<AppShellRefs | null>(null);
